
const state = {
  isVisible: false,
  type: null, // success & error
  message: null
}

const getters = {
  toasterState () {
    return state
  }
}

const actions = {
  setToaster ({ commit }, toaster) {
    commit('setToaster', toaster)
    setTimeout(function () {
      commit('setToaster', {status: false, type: null, message: null})
    }, 3000)
  }
}

const mutations = {
  setToaster (state, toaster) {
    state.isVisible = toaster.status
    state.type = toaster.type
    state.message = toaster.message
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/toaster.js